import { render, staticRenderFns } from "./VStatusChanger.vue?vue&type=template&id=0e815c5a"
import script from "./VStatusChanger.vue?vue&type=script&lang=js"
export * from "./VStatusChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports